module.exports = __webpack_public_path__ + "static/media/plaza-2.9466d950.webp";